import React, { useEffect } from "react";
import Modal from "../../shared/modal/Modal";
import musicController from "../../audio/music-controller";
import styles from "./RoyaleItemMoments.module.scss";

// The Store's moments for an item that is won, not bought (the Royale's crown):
//   Locked  a click on it before it is won: the "denied" sound and a word on
//           how it is earned (no price: money can't buy it).
//   Unlock  the first time it is opened after it is won: the item rises out of
//           a burst of light, once; then it is an ordinary owned item.

export function LockedRoyaleItem({ name, preview, onClose, onJoin }: { name: string; preview: React.ReactNode; onClose: () => void; onJoin: () => void }) {
  useEffect(() => { musicController.play("ui-error"); }, []);
  return (
    <Modal title="Nice try" onClose={onClose} className={styles.modal}>
      <div className={styles.locked}>
        <div className={styles.lockedPreview}>{preview}<span className={styles.lock} aria-hidden="true">🔒</span></div>
        <p className={styles.big}>The {name} is not for sale.</p>
        <p>Your money means nothing. Win the Royale and beat the 29 other worms to claim your well-earned reward!</p>
        <div className={styles.btns}>
          <button type="button" className={styles.ghost} onClick={onClose}>Maybe later</button>
          <button type="button" className={styles.gold} data-sound="confirm" onClick={onJoin}>Join the next Royale</button>
        </div>
      </div>
    </Modal>
  );
}

export function UnlockMoment({ name, preview, onEquip, onClose }: { name: string; preview: React.ReactNode; onEquip: () => void; onClose: () => void }) {
  useEffect(() => { musicController.play("unbox"); const id = window.setTimeout(() => musicController.play("rank-up"), 650); return () => window.clearTimeout(id); }, []);
  return (
    <Modal title="Unlocked" onClose={onClose} className={styles.modal}>
      <div className={styles.unlock}>
        <div className={styles.stage}>
          <i className={styles.rays} aria-hidden="true" />
          <span className={styles.sparks} aria-hidden="true">{Array.from({ length: 12 }, (_, i) => <i key={i} style={{ "--a": `${i * 30}deg`, "--d": `${0.55 + (i % 4) * 0.06}s` } as React.CSSProperties} />)}</span>
          <div className={styles.rise}>{preview}</div>
        </div>
        <small className={styles.kicker}>Royale winner</small>
        <b className={styles.title}>{name}</b>
        <p>Won, not bought. Wear it so they all know.</p>
        <div className={styles.btns}>
          <button type="button" className={styles.ghost} onClick={onClose}>Later</button>
          <button type="button" className={styles.gold} data-sound="confirm" onClick={onEquip}>Wear it</button>
        </div>
      </div>
    </Modal>
  );
}
